import React, { useState } from 'react';
import useEstadoCuentaFiltros from './useEstadoCuentaFiltros';
import PropTypes from 'prop-types';
import { Card, Tabs, Tab } from 'react-bootstrap';
import EstadoCuentaHeader from './EstadoCuentaHeader';
import EstadoCuentaFiltros from './EstadoCuentaFiltros';
import EstadoCuentaResumen from './EstadoCuentaResumen';
import EstadoCuentaLista from './EstadoCuentaLista';
import ModalFacturaConciliada from './ModalFacturaConciliada';

const PanelEstadoCuenta = ({
    rfcSeleccionado,
    cargando,
    periodoEstadoCuenta,
    setPeriodoEstadoCuenta,
    tipoMovimiento,
    setTipoMovimiento,
    movimientosFiltrados,
    handleSeleccionarArchivo,
    cuentasBancarias,
    cuentaSeleccionada,
    setCuentaSeleccionada,
    movimientosSeleccionados = [],
    toggleSeleccionMovimiento,
    toggleSeleccionTodos,
    setShowModalEliminar,
    onDesconciliar,
    cargandoConciliacion,
    handleGenerarReportePDF
}) => {
    const { activeTab, setActiveTab } = useEstadoCuentaFiltros();
    
    // Estado para modal de factura conciliada
    const [showModalFactura, setShowModalFactura] = useState(false);
    const [movimientoParaModal, setMovimientoParaModal] = useState(null);

    const handleOpenModalFactura = (mov) => {
        setMovimientoParaModal(mov);
        setShowModalFactura(true);
    };

    const handleCloseModalFactura = () => {
        setShowModalFactura(false);
        setMovimientoParaModal(null);
    };

    const movsPorConciliar = movimientosFiltrados.filter(m => m.monto > 0);
    const movsConciliados = movimientosFiltrados.filter(m => m.montoConciliado > 0);

    const calcularTotales = (movs, isConciliados) => {
        const ingresos = movs
            .filter(m => m.tipo === 'I')
            .reduce((sum, m) => sum + (isConciliados ? m.montoConciliado : m.monto), 0);

        const egresos = movs
            .filter(m => m.tipo === 'E')
            .reduce((sum, m) => sum + (isConciliados ? m.montoConciliado : m.monto), 0);

        return { ingresos, egresos, neto: ingresos - egresos };
    };

    const totalesPorConciliar = calcularTotales(movsPorConciliar, false);
    const totalesConciliados = calcularTotales(movsConciliados, true);

    return (
        <>
        <Card className="shadow-sm h-100">
            <Card.Header className="bg-light border-bottom py-3">
                <EstadoCuentaHeader
                    rfcSeleccionado={rfcSeleccionado}
                    cargando={cargando}
                    handleSeleccionarArchivo={handleSeleccionarArchivo}
                    cuentaSeleccionada={cuentaSeleccionada}
                    movimientosSeleccionados={movimientosSeleccionados}
                    setShowModalEliminar={setShowModalEliminar}
                    handleGenerarReportePDF={handleGenerarReportePDF}
                />
            </Card.Header>

            <EstadoCuentaFiltros
                rfcSeleccionado={rfcSeleccionado}
                periodoEstadoCuenta={periodoEstadoCuenta}
                setPeriodoEstadoCuenta={setPeriodoEstadoCuenta}
                tipoMovimiento={tipoMovimiento}
                setTipoMovimiento={setTipoMovimiento}
                cuentasBancarias={cuentasBancarias}
                cuentaSeleccionada={cuentaSeleccionada}
                setCuentaSeleccionada={setCuentaSeleccionada}
                cargandoConciliacion={cargandoConciliacion}
            />

            <Card.Body className="p-0">
                {!cuentaSeleccionada ? (
                    <div className="p-5 text-center">
                        <i className="fas fa-hand-pointer fa-3x text-300 mb-3"></i>
                        <h5 className="text-500">Seleccione una cuenta bancaria</h5>
                        <p className="text-500 mb-0">Elija una cuenta para ver sus movimientos y conciliaciones.</p>
                    </div>
                ) : (
                    <Tabs
                        id="tabs-movimientos"
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="mb-0 border-bottom"
                    >
                        <Tab eventKey="por-conciliar" title="Por Conciliar">
                            <EstadoCuentaResumen totales={totalesPorConciliar} />
                            <EstadoCuentaLista
                                rfcSeleccionado={rfcSeleccionado}
                                movimientosFiltrados={movsPorConciliar}
                                movimientosSeleccionados={movimientosSeleccionados}
                                toggleSeleccionMovimiento={toggleSeleccionMovimiento}
                                toggleSeleccionTodos={toggleSeleccionTodos}
                                cargandoConciliacion={cargandoConciliacion}
                            />
                        </Tab>
                        <Tab eventKey="conciliados" title="Conciliados">
                            <EstadoCuentaResumen totales={totalesConciliados} />
                            <EstadoCuentaLista
                                rfcSeleccionado={rfcSeleccionado}
                                movimientosFiltrados={movsConciliados}
                                movimientosSeleccionados={movimientosSeleccionados}
                                toggleSeleccionMovimiento={toggleSeleccionMovimiento}
                                toggleSeleccionTodos={toggleSeleccionTodos}
                                esConciliadosTab={true}
                                onMovimientoClick={handleOpenModalFactura}
                            />
                        </Tab>
                    </Tabs>
                )}
            </Card.Body>
        </Card>

        <ModalFacturaConciliada
            show={showModalFactura}
            handleClose={handleCloseModalFactura}
            movimiento={movimientoParaModal}
            onDesconciliar={onDesconciliar}
        />
        </>
    );
};



PanelEstadoCuenta.propTypes = {
    rfcSeleccionado: PropTypes.string,
    cargando: PropTypes.bool,
    periodoEstadoCuenta: PropTypes.instanceOf(Date),
    setPeriodoEstadoCuenta: PropTypes.func,
    tipoMovimiento: PropTypes.string,
    setTipoMovimiento: PropTypes.func,
    totales: PropTypes.object,
    movimientosFiltrados: PropTypes.array,
    handleSeleccionarArchivo: PropTypes.func,
    cuentasBancarias: PropTypes.array,
    cuentaSeleccionada: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setCuentaSeleccionada: PropTypes.func,
    movimientosSeleccionados: PropTypes.array,
    toggleSeleccionMovimiento: PropTypes.func,
    toggleSeleccionTodos: PropTypes.func,
    setShowModalEliminar: PropTypes.func,
    onDesconciliar: PropTypes.func
};

export default PanelEstadoCuenta;
